import { render, staticRenderFns } from "./StatsTeamComms.vue?vue&type=template&id=1e5ff7a0&scoped=true&"
import script from "./StatsTeamComms.vue?vue&type=script&lang=js&"
export * from "./StatsTeamComms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5ff7a0",
  null
  
)

export default component.exports